import { render, staticRenderFns } from "./CDEKCreation.vue?vue&type=template&id=c0bb0576&scoped=true"
import script from "./CDEKCreation.vue?vue&type=script&lang=js"
export * from "./CDEKCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bb0576",
  null
  
)

export default component.exports